import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon, LeafIcon, ArrowUpRightIcon } from 'lucide-react';
interface QuickLink {
  label: string;
  href: string;
}
const QUICK_LINKS: QuickLink[] = [{
  label: 'Los 6 tomos',
  href: '#tomos'
}, {
  label: 'Qué incluye',
  href: '#incluye'
}, {
  label: 'Bonos',
  href: '#bonos'
}, {
  label: 'Preguntas frecuentes',
  href: '#faq'
}, {
  label: 'Acceder al MegaPack',
  href: '#comprar'
}];
const LEGAL_LINKS: QuickLink[] = [{
  label: 'Términos y condiciones',
  href: '#faq'
}, {
  label: 'Política de privacidad',
  href: '#faq'
}, {
  label: 'Política de reembolso',
  href: '#faq'
}];
export function Footer() {
  return <footer id="site-footer" className="relative overflow-hidden bg-sand" data-id="element-62" data-mp="3lggb2qn7mxdi">
      <div className="h-px w-full bg-gold/30" aria-hidden data-id="element-63" data-mp="3qbvm7atu2f68" />
      <div className="pointer-events-none absolute -bottom-28 -right-20 h-72 w-72 rounded-full bg-stone/50 blur-3xl" aria-hidden data-id="element-64" data-mp="29ynldknsn5e0" />

      <div className="relative mx-auto max-w-6xl px-5 py-12 sm:py-14" data-id="element-65" data-mp="2ezl0tphf5lbt">
        <div className="grid gap-8 md:grid-cols-3 md:gap-8 lg:gap-12" data-id="element-66" data-mp="3labovo69tsmo">
          {/* Marca y producto */}
          <div className="md:col-span-1" data-id="element-67" data-mp="3gc0ftfnsvm5i">
            <p className="font-display text-2xl leading-tight text-charcoal" data-id="element-68" data-mp="3v7q7nufo2ti5">
              Wellness Digital <span className="text-gold-deep" data-id="element-69" data-mp="3q8mzw28ay96h">PRO™</span>
            </p>
            <p className="mt-3 inline-flex items-center gap-1.5 rounded-full border border-gold/40 bg-ivory px-3 py-1 text-[0.62rem] font-semibold uppercase tracking-editorial text-gold-deep" data-id="element-70" data-mp="3q7bxa5qlf7gy">
              <LeafIcon className="h-3 w-3 text-gold-deep" aria-hidden data-id="element-71" data-mp="33nlq3us7fjn" />
              MegaPack 6 en 1
            </p>
            <p className="mt-4 max-w-sm text-[0.82rem] leading-relaxed text-charcoal/65" data-id="element-72" data-mp="huwlh5seehai">
              El sistema para profesionales de Yoga, Pilates, Coaching, Meditación y Terapias de
              Argentina que quieren convertir Instagram en una herramienta para atraer alumnos y
              clientes.
            </p>
            <p className="mt-4 max-w-sm font-display text-base italic leading-snug text-charcoal/80" data-id="element-73" data-mp="tvd13wd6udh9">
              Porque dedicarte al bienestar de otros no debería costarte tu propio bienestar. 🌿
            </p>
          </div>

          {/* Enlaces rápidos */}
          <nav aria-label="Enlaces rápidos" data-id="element-74" data-mp="13r7mgz8sqmnq">
            <h2 className="text-[0.62rem] font-semibold uppercase tracking-editorial text-gold-deep" data-id="element-75" data-mp="18kiydesgttmi">
              Explorá el pack
            </h2>
            <ul className="mt-4 space-y-2" data-id="element-76" data-mp="1clcma85wr8fe">
              {QUICK_LINKS.map(link => <li key={link.label} data-id="element-77" data-mp="1hj4e726jyujl">
                  <a href={link.href} className="group inline-flex items-center gap-1.5 text-[0.82rem] text-charcoal/70 transition-colors hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold/40" data-id="element-78" data-mp="1mjs9i01tdxjm">
                    {link.label}
                    <ArrowUpRightIcon className="h-3.5 w-3.5 text-gold/60 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-gold-deep" aria-hidden data-id="element-79" data-mp="3tb1a812bsqk5" />
                  </a>
                </li>)}
            </ul>
          </nav>

          {/* Soporte */}
          <div data-id="element-80" data-mp="1wo8okr7gzamd">
            <h2 className="text-[0.62rem] font-semibold uppercase tracking-editorial text-gold-deep" data-id="element-81" data-mp="1worxjif56oo9">
              Soporte
            </h2>
            <ul className="mt-4 space-y-2 text-[0.82rem]" data-id="element-82" data-mp="2tbvfyapos2sy">
              <li data-id="element-83" data-mp="2pdpg7mn9mnhj">
                <a href="mailto:soporte@creativodigital.shop" className="inline-flex items-center gap-2.5 text-charcoal/70 transition-colors hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold/40" data-id="element-84" data-mp="2pd5wq1hyvr1e">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-ivory ring-1 ring-stone" data-id="element-85" data-mp="18w1n5dmw0dg3">
                    <MailIcon className="h-4 w-4 text-gold-deep" aria-hidden data-id="element-86" data-mp="2rvzlfa75dzs4" />
                  </span>
                  soporte@creativodigital.shop
                </a>
              </li>
              <li data-id="element-87" data-mp="2woaim5ai77gz">
                <a href="https://instagram.com/creativodigitalstudio" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2.5 text-charcoal/70 transition-colors hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold/40" data-id="element-88" data-mp="2ivkyk6ejccmi">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-ivory ring-1 ring-stone" data-id="element-89" data-mp="31lj2cabavjkc">
                    <InstagramIcon className="h-4 w-4 text-gold-deep" aria-hidden data-id="element-90" data-mp="36juewsszc869" />
                  </span>
                  @creativodigitalstudio
                </a>
              </li>
              <li data-id="element-91" data-mp="1v603ip53xowv">
                <a href="https://www.creativodigital.shop" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2.5 text-charcoal/70 transition-colors hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold/40" data-id="element-92" data-mp="1v6i581ajgvc6">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-ivory ring-1 ring-stone" data-id="element-93" data-mp="1rn1a91e3xx0e">
                    <GlobeIcon className="h-4 w-4 text-gold-deep" aria-hidden data-id="element-94" data-mp="13yrt4cru9xfl" />
                  </span>
                  www.creativodigital.shop
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Legales */}
        <ul className="mt-8 flex flex-wrap gap-x-5 gap-y-2 text-[0.72rem] text-charcoal/45" data-id="element-95" data-mp="18x1qmu11da4d">
          {LEGAL_LINKS.map(link => <li key={link.label} data-id="element-96" data-mp="l6ffuuzndbqo">
              <a href={link.href} className="transition-colors hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold/40" data-id="element-97" data-mp="l5nyop6srgjx">
                {link.label}
              </a>
            </li>)}
        </ul>

        {/* Cierre */}
        <div className="mt-5 border-t border-stone pt-5" data-id="element-98" data-mp="2q0oz51ojljiv">
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between" data-id="element-99" data-mp="2q18f4cumtxu9">
            <p className="text-[0.72rem] text-charcoal/50" data-id="element-100" data-mp="2uyqg9h2er8rp">
              © Creativo Digital™ 2026 — Todos los derechos reservados.
            </p>
            <p className="text-[0.72rem] text-charcoal/45" data-id="element-101" data-mp="22acgowvo84e1">
              Un producto de{' '}
              <a href="https://www.creativodigital.shop" target="_blank" rel="noreferrer" className="font-semibold text-gold-deep transition-colors hover:text-gold focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold/40" data-id="element-102" data-mp="27a76sy7mgpy1">
                Creativo Digital
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>;
}